import { useQuery } from '@tanstack/react-query'

import { useQueryWithStorage } from '@hooks/useQueryWithStorage'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchWerkbakken, initialState } from '../services/fetchWerkbakken'

import { useWerkbakkenStore } from './useWerkbakkenStore'

export { useWerkbakken, queryKey }

const queryKey = 'werkbakken'

const useQueryStore = () => {
  const { query, storeQuery } = useWerkbakkenStore()

  return useQueryWithStorage({
    initialState: initialState,
    query,
    storeQuery,
    queryKey,
  })
}

const useWerkbakken = () => {
  const { onChangeFilters, onReset, query } = useQueryStore()
  const { hasPermissions, canViewOpdrachten } = useAuthenticatedUser()

  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => fetchWerkbakken({ query }),
    enabled: hasPermissions && canViewOpdrachten,
    refetchOnMount: true,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
    filters: query.filters,
    initialFilters: initialState.query.filters,
    onChangeFilters,
    onReset,
    onRefresh: refetch,
  }
}
